__turbopack_context__.v({
  "container": "plan-card-module-scss-module__g-6JDq__container",
  "styled-list": "plan-card-module-scss-module__g-6JDq__styled-list",
  "text": "plan-card-module-scss-module__g-6JDq__text",
  "title": "plan-card-module-scss-module__g-6JDq__title",
});
